// JavaScript entrypoint for the age-gate component.
import { disablePageScroll, enablePageScroll } from 'vendor.noscroll';
import { isbot } from 'vendor.isbot';

function getAge(birthdate) {
  const today = new Date();
  let age = today.getFullYear() - birthdate.getFullYear();
  const m = today.getMonth() - birthdate.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < birthdate.getDate())) {
    age--;
  }

  return age;
}

class AgeGate extends HTMLElement {
  #minimumAge = 18;
  #ageGateFormEl = null;
  #ageGateErrorEl = null;

  constructor() {
    super();

    this.#ageGateFormEl = this.querySelector('[data-age-gate]');
    this.#ageGateErrorEl = this.#ageGateFormEl.querySelector(
      '[data-age-gate-error]'
    );
    this.#ageGateFormEl.addEventListener(
      'submit',
      this.#onFormSubmit.bind(this)
    );

    if (isbot(navigator.userAgent)) {
      this.close();
    } else if (this.style.display === '') {
      this.open();
    }
  }

  open() {
    disablePageScroll();
    this.style.display = '';
  }

  close() {
    enablePageScroll();
    this.style.display = 'none';
  }

  #onFormSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    const data = new FormData(event.target);
    const day = data.get('day');
    const month = data.get('month');
    const year = data.get('year');

    if (day === '' || month === '' || year === '') return;

    const age = getAge(new Date(year, month, day));

    if (age >= this.#minimumAge) {
      this.close();
      sessionStorage.setItem('age-gate', age);
    } else {
      this.#ageGateErrorEl.style.display = '';
    }
  }
}

customElements.define('age-gate', AgeGate);
